export default {
	performances: (artistId: string) => `/artist/${artistId}/performances`,
	top: (artistId: string) => `/artist/${artistId}/top`,
	favorites: (artistId: string) => `/artist/${artistId}/favorites`,
	map: (artistId: string) => `/artist/${artistId}/map`,
	demographics: (artistId: string) => `/artist/${artistId}/demographics`,
	streamingContext: (artistId: string) =>
		`/artist/${artistId}/streaming-context`,
	createArtistHighlight: (artistId: string) =>
		`/edit/artist/${artistId}/highlight`,
	editArtistHighlight: (artistId: string, highlightId: string) =>
		`/edit/artist/${artistId}/highlight/${highlightId}`,
	artist: (artistId: string) => `/edit/artist/${artistId}`,
	artistBiography: (artistId: string) => `/edit/artist/${artistId}/biography`,
	artistPicture: (artistId: string) => `/edit/artist/${artistId}/picture`,
};
